module.exports = __webpack_public_path__ + "ba7e2cbd7d83e09c41b6e658a1e7078e-811_hero_alt_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/header/assets/811_hero_alt_2x.jpg
// module id = 572
// module chunks = 0